import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Header({ variant = "home" }) {
  const { t, lang, toggle } = useLang();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const isSub = variant !== "home";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 bg-paper/90 backdrop-blur-xl border-b transition-colors duration-300 ${
        scrolled ? "border-line" : "border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-8 h-16 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          {isSub && (
            <button
              onClick={() => navigate("/")}
              aria-label={t.nav.home}
              data-testid="header-back"
              className="grid place-items-center h-10 w-10 rounded-full border border-line hover:bg-mist transition-colors shrink-0"
            >
              <ArrowLeft size={18} />
            </button>
          )}
          <Link to="/" className="flex items-baseline gap-1.5 select-none min-w-0" data-testid="logo">
            <span className="font-serif font-semibold text-xl leading-none tracking-tight truncate">Hollanda</span>
            <span className="font-serif text-xl leading-none tracking-tight text-brand">Emlak</span>
          </Link>
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={toggle}
            aria-label="Language"
            data-testid="lang-toggle"
            className="flex items-center h-9 rounded-full border border-line text-sm font-medium overflow-hidden"
          >
            <span className={`px-2.5 h-full flex items-center ${lang === "tr" ? "bg-ink text-paper" : "text-stone"}`}>TR</span>
            <span className={`px-2.5 h-full flex items-center ${lang === "nl" ? "bg-ink text-paper" : "text-stone"}`}>NL</span>
          </button>
        </div>
      </div>
    </header>
  );
}
